import { render, staticRenderFns } from "./BasicHeader.vue?vue&type=template&id=169f6686&scoped=true&"
import script from "./BasicHeader.vue?vue&type=script&lang=js&"
export * from "./BasicHeader.vue?vue&type=script&lang=js&"
import style0 from "./BasicHeader.vue?vue&type=style&index=0&lang=less&"
import style1 from "./BasicHeader.vue?vue&type=style&index=1&id=169f6686&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169f6686",
  null
  
)

export default component.exports